import React from 'react'
import { Card } from 'antd';
import Styles from './HomeTilesStyles.module.css';
import{ReactComponent as TileIcon} from '../../Icons/TileIcon.svg';
import { Home_PAGE_URL } from '../../Router/routerUrl';
import { useNavigate } from 'react-router-dom';

export default function HomeTile({data}) {
    const {title, description, routing} = data;
    const navigate = useNavigate();
    const onNavigate=(route)=>{
      navigate(`${Home_PAGE_URL}${route}`)
    }
  return (
    <>
    <Card className={Styles.homeTiles}>
    <div style={{fontSize:'16px', fontWeight:'500', lineHeight:'24px', color:'#2A364A', height:'24px'}}>{title}</div>
    <div style={{fontSize:'14px', fontWeight:'400', lineHeight:'22px',marginTop:'16px', color: '#344054CC', height:'66px'}}>{description}</div>
    <div style={{height:'80px',display:'flex', justifyContent:'end', alignItems:'end'}}><TileIcon style={{cursor:'pointer'}} onClick={()=>{
        onNavigate(routing);
    }}/></div>
    </Card>
    </>
  )
}
